import { QueryClient, useMutation } from "@tanstack/react-query"
import { AddReportDataType, UpdateReportDataType } from "../types"
import { useState } from "react"
import {
    deleteReport,
    postNewReport,
    toggleReportArchive,
    updateReport,
} from "./apiCalls"
import { messageError, messagePending, messageSuccess } from "../../../services/messages"
import { apiErrorMessage } from "../../../services/apiErrorText"

// ADD report
export const useAddReportMutation = (queryClient: QueryClient, refreshData: string) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, AddReportDataType>({
        mutationFn: postNewReport,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Der Bericht wird gerade erstellt.")
        },
        onSuccess: () => {
            messageSuccess(notificationKey, "Fertig!", "Der Bericht wurde erfolgreich erstellt.")
            queryClient.invalidateQueries({
                queryKey: [refreshData],
            })
        },
        onError: (err: any) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Der Bericht konnte nicht erstellt werden."))
            console.log(err)
        },
    })
    return mutation
}

// UPDATE report
export const useUpdateReportMutation = (queryClient: QueryClient, refreshData: string) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, { id: string; body: UpdateReportDataType }>({
        mutationFn: updateReport,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Der Bericht wird gerade aktualisiert.")
        },
        onSuccess: () => {
            messageSuccess(notificationKey, "Fertig!", "Der Bericht wurde erfolgreich aktualisiert.")
            queryClient.invalidateQueries({
                queryKey: [refreshData],
            })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Der Bericht konnte nicht aktualisiert werden."))
            console.log(err)
        },
    })
    return mutation
}

// DELETE report
export const useDeleteReportMutation = (queryClient: QueryClient, refreshData: string) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, string>({
        mutationFn: deleteReport,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Der Bericht wird gerade gelöscht.")
        },
        onSuccess: () => {
            messageSuccess(notificationKey, "Fertig!", "Der Bericht wurde erfolgreich gelöscht.")
            queryClient.invalidateQueries({
                queryKey: [refreshData],
            })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Der Bericht konnte nicht gelöscht werden."))
            console.log(err)
        },
    })
    return mutation
}

// TOGGLE archive report
export const useToggleReportArchiveMutation = (queryClient: QueryClient, refreshData: string) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, string>({
        mutationFn: toggleReportArchive,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Der Bericht wird gerade archiviert/entarchiviert.")
        },
        onSuccess: () => {
            messageSuccess(notificationKey, "Fertig!", "Der Bericht wurde erfolgreich aktualisiert.")
            queryClient.invalidateQueries({
                queryKey: [refreshData],
            })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Der Bericht konnte nicht aktualisiert werden."))
            console.log(err)
        },
    })
    return mutation
}
